document.addEventListener("DOMContentLoaded", function () {

  const container = document.querySelector("[data-reading-time]");
  const article = document.querySelector(".article-mdc");

  if (!container || !article) return;

  const text = article.innerText || "";
  const words = text.trim().split(/\s+/).length;
  const minutes = Math.max(1, Math.round(words / 220));

  container.textContent = `⏱️ Temps de lecture : ${minutes} min`;

});
